var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1Your(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 120,
    viewBox: "0 0 300 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.374,
    y1: -0.329,
    x2: 0.981,
    y2: 0.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84e0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cbe8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4905b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Bg",
    "data-name": "Icon Bg",
    width: 300,
    height: 120,
    rx: 20,
    transform: "translate(85 39)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card_1",
    "data-name": "Card 1",
    transform: "translate(-1587 -927)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Bg-2",
    "data-name": "Icon Bg",
    width: 300,
    height: 120,
    rx: 20,
    transform: "translate(1587 927)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(1502 888)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M71.48,26.231H1.967A1.967,1.967,0,0,1,0,24.264v-5.9a7.869,7.869,0,0,1,7.869-7.869h7.869V1.967A1.967,1.967,0,0,1,17.706,0h6.558a1.967,1.967,0,0,1,1.967,1.967v8.525H47.216V1.967A1.967,1.967,0,0,1,49.184,0h6.558a1.967,1.967,0,0,1,1.967,1.967v8.525h7.869a7.869,7.869,0,0,1,7.869,7.869v5.9A1.967,1.967,0,0,1,71.48,26.231ZM1.967,31.477H71.48a1.967,1.967,0,0,1,1.967,1.967V76.071a7.869,7.869,0,0,1-7.869,7.869H7.869A7.869,7.869,0,0,1,0,76.071V33.445A1.967,1.967,0,0,1,1.967,31.477ZM56.61,47.208l-4.618-4.656a1.967,1.967,0,0,0-2.782-.011L31.825,59.785l-7.538-7.6a1.967,1.967,0,0,0-2.782-.011l-4.656,4.618a1.967,1.967,0,0,0-.011,2.782L30.38,73.227a1.967,1.967,0,0,0,2.782.011L56.6,49.99a1.967,1.967,0,0,0,.011-2.782Z",
    transform: "translate(312 76.06)",
    opacity: 0.08
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Your);
export default __webpack_public_path__ + "static/media/Card1your.d220dd08ff2fa509c0d986c25e4edafc.svg";
export { ForwardRef as ReactComponent };